import React from 'react';
import { Icon, Menu, MenuItem, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import OfflinePinIcon from '@mui/icons-material/OfflinePin';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import CancelIcon from '@mui/icons-material/Cancel';
import PlaylistAddCircleIcon from '@mui/icons-material/PlaylistAddCircle';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';

import { StatusMenuProps } from '../../helpers/types';


type StatusType = 'discarded' | 'benign' | 'confirmed' | 'trademark' | 'owned' | 'pre-confirmed'| 'detected';

type StatusValueType = {
  label: string;
  icon: React.ComponentType | string;
  color: string;
};

type ValuesMapType = {
  [K in StatusType]: StatusValueType;
};

const calcLabelAndIconFromStatus = (status: StatusType): StatusValueType => {
  const valuesMap: ValuesMapType = {
    discarded: {
      label: 'Discard',
      icon: CancelIcon,
      color: ''
    },
    benign: {
      label: 'Benign',
      icon: VerifiedUserIcon,
      color: ''
    },
    confirmed: {
      label: 'Confirm',
      icon: CheckCircleIcon,
      color: ''
    },
    trademark: {
      label: 'Trademark',
      icon: OfflinePinIcon,
      color: ''
    },
    owned: {
      label: 'Owned',
      icon: PlaylistAddCircleIcon,
      color: ''
    },
    'pre-confirmed': {
      label: 'Pre-Confirmed',
      icon: AssignmentTurnedInIcon,
      color: ''
    },
    detected: {
      label: 'Detected',
      icon: '',
      color: ''
    },
  };
  return valuesMap[status];
}


const StatusMenu = ({
  openStatusMenu,
  closeStatusMenu,
  items,
  handleOnClick,
}: StatusMenuProps) => {
  return (
    <Menu
      sx={{ mt: '45px' }}
      anchorEl={openStatusMenu}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={Boolean(openStatusMenu)}
      onClose={closeStatusMenu}>
      {items?.map((item: string) => {
        const mappedItem = calcLabelAndIconFromStatus(item as StatusType);
        return (
          <MenuItem key={item} data-testid={`threats-status-set-${item}`} onClick={() => handleOnClick(item)}
            style={{minHeight: '50px', color: mappedItem.color}}>
            {typeof mappedItem.icon === 'string' ? (
              <Icon sx={{}}>{mappedItem.icon}</Icon>
            ) : (
              mappedItem.icon && React.createElement(mappedItem.icon)
            )}
            <Typography textAlign="center" sx={{ ml: 1 }}>{mappedItem.label}</Typography>
          </MenuItem>
        )
      })}
    </Menu>
  );
};

export default StatusMenu;
